import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { FORM_ERROR } from 'final-form';
import { loggedIn, requestPasswordReset2 } from 'actions/auth';

import RequestPasswordResetForm from 'components/forms/RequestPasswordResetForm';
import { Link } from 'react-router';
import Logo from 'components/Logo';
import ThemeToggle from 'components/ThemeToggle';


const messages = defineMessages({
  RESET_PASSWORD: {
    id: 'RequestPasswordReset.RESET_PASSWORD',
    defaultMessage: 'Passwort zurücksetzen',
  },
  INDICATE_MAIL_OR_PHONE: {
    id: 'RequestPasswordReset.INDICATE_MAIL_OR_PHONE',
    defaultMessage: 'Bitte geben Sie Ihre E-Mail Adresse oder Ihre Telefonnummer an.',
  },
  MAIL_RESET_PASSWORD: {
    id: 'RequestPasswordReset.MAIL_RESET_PASSWORD',
    defaultMessage: 'Wir werden dann einen Link an diese Adresse senden um Ihnen ein neues Passwort zu erstellen.',
  },
  BACK: {
    id: 'RequestPasswordReset.BACK',
    defaultMessage: 'Zurück zum Login',
  },
});

class RequestPasswordReset extends React.PureComponent {
    render() {
      const { intl: { formatMessage } } = this.props;

        return (
            <div className="anonymous-container" style={{ minHeight: '100vh', width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', background: 'var(--bg-color)' }}>
                <div className="anonymous-card-wrapper" style={{ width: '100%', maxWidth: '480px' }}>
                    <div className="anonymous-card" style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '32px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                        {/* Logo Header */}
                        <div className="anonymous-header" style={{ position: 'relative', padding: '32px 0', borderBottom: '1px solid var(--panel-border)', backgroundColor: 'var(--panel-bg)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Logo large />
                            <div className="anonymous-theme-toggle">
                                <ThemeToggle />
                            </div>
                        </div>

                        {/* Content */}
                        <div style={{ padding: '40px 48px' }}>
                            <h1 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: 'bold', color: 'var(--text-color)' }}>
                                {formatMessage(messages.RESET_PASSWORD)}
                            </h1>
                            <p style={{ color: 'var(--text-muted)', fontSize: '15px', lineHeight: '1.6', marginBottom: '32px' }}>
                                {formatMessage(messages.INDICATE_MAIL_OR_PHONE)}{' '}
                                {formatMessage(messages.MAIL_RESET_PASSWORD)}
                            </p>
                            <RequestPasswordResetForm onSubmit={this.props.action} />
                            <div style={{ marginTop: '24px', textAlign: 'center' }}>
                                <Link
                                    to="/"
                                    style={{ color: 'var(--text-muted)', textDecoration: 'none', fontWeight: '500', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                                    onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'}
                                    onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}
                                >
                                    <i className="fa fa-arrow-left" aria-hidden="true" /> {formatMessage(messages.BACK)}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null,
  dispatch => ({
    action: async formData => {
      const data = await requestPasswordReset2(formData);
      if (data.response) {
        dispatch(push('/requestPasswortReset/success/'))
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    },
  })
)(injectIntl(RequestPasswordReset));
